var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotaldevices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5735 3.15988L20.6108 2.12249C19.9938 1.4533 19.2448 0.919209 18.4111 0.553904C17.5773 0.188599 16.6769 0 15.7667 0C14.8564 0 13.956 0.188599 13.1223 0.553904C12.2886 0.919209 11.5395 1.4533 10.9225 2.12249L11.9599 3.15988C12.4405 2.62687 13.0277 2.20074 13.6835 1.90906C14.3393 1.61738 15.049 1.46666 15.7667 1.46666C16.4844 1.46666 17.1941 1.61738 17.8499 1.90906C18.5056 2.20074 19.0928 2.62687 19.5735 3.15988Z",
    fill: "#5DA3E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.999 4.19901L14.0394 5.23943C14.2449 4.97781 14.5071 4.76629 14.8063 4.62083C15.1055 4.47538 15.4338 4.3998 15.7665 4.3998C16.0992 4.3998 16.4275 4.47538 16.7267 4.62083C17.0258 4.76629 17.2881 4.97781 17.4935 5.23943L18.5339 4.19901C18.1905 3.80179 17.7655 3.48316 17.288 3.26477C16.8104 3.04637 16.2914 2.93333 15.7663 2.93333C15.2412 2.93333 14.7222 3.04637 14.2446 3.26477C13.7671 3.48316 13.3421 3.80179 12.9987 4.19901H12.999Z",
    fill: "#5DA3E9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9 9.90001H16.5V6.96667H15.0333V9.90001H1.1C0.808366 9.90035 0.528774 10.0163 0.322558 10.2226C0.116341 10.4288 0.000339645 10.7084 0 11V16.1333C0.000339645 16.425 0.116341 16.7046 0.322558 16.9108C0.528774 17.117 0.808366 17.233 1.1 17.2333H20.9C21.1916 17.233 21.4712 17.117 21.6774 16.9108C21.8837 16.7046 21.9997 16.425 22 16.1333V11C21.9997 10.7084 21.8837 10.4288 21.6774 10.2226C21.4712 10.0163 21.1916 9.90035 20.9 9.90001ZM20.5333 15.7667H1.46667V11.3667H20.5333V15.7667Z",
    fill: "#5DA3E9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.13334 12.8333H3.66667V14.3H5.13334V12.8333Z",
    fill: "#5DA3E9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.79999 12.8333H7.33333V14.3H8.79999V12.8333Z",
    fill: "#5DA3E9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4667 12.8333H11V14.3H12.4667V12.8333Z",
    fill: "#5DA3E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotaldevices);
export default __webpack_public_path__ + "static/media/total devices.96c185fccaa952f29b6d9cdc1dfe210c.svg";
export { ForwardRef as ReactComponent };